var _style, _path, _path2, _g, _path3, _path4, _path5, _path6;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function Svg10(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "\\uB808\\uC774\\uC5B4_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    width: "3000px",
    height: "3000px",
    viewBox: "0 0 3000 3000",
    style: {
      enableBackground: "new 0 0 3000 3000"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\r\n\t.st0{fill:#494949;}\r\n\t.st1{fill:#353535;}\r\n\t.st2{fill:#C9C9C9;}\r\n\t.st3{fill:#EF4C48;}\r\n\t.st4{fill:#FFB31A;}\r\n\t.st5{fill:#379B29;}\r\n\t.st6{fill:#1E1E1E;}\r\n")), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M2947,3000H53.1c-29.3,0-53.1-23.8-53.1-53.1V53.1C0,23.8,23.8,0,53.1,0H2947c29.3,0,53.1,23.8,53.1,53.1 v2893.8C3000.1,2976.2,2976.3,3000,2947,3000z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M1907,94.6l43.4,137h-820.2l43.4-137c7.7-24.4,30.4-41,56-41H1851C1876.6,53.5,1899.3,70.1,1907,94.6z"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M513.5,425.7c-19.3,0-34.9-15.7-34.9-34.9c0-19.3,15.7-34.9,34.9-34.9c19.2,0,34.9,15.7,34.9,34.9 S532.7,425.7,513.5,425.7z M513.5,369c-12,0-21.8,9.8-21.8,21.8s9.8,21.8,21.8,21.8s21.8-9.8,21.8-21.8S525.5,369,513.5,369z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M560.4,439.4c-1.5,0-3.1-0.5-4.3-1.6L529.9,415c-2.7-2.4-3-6.5-0.6-9.3c2.4-2.7,6.5-3,9.3-0.6l26.1,22.8 c2.7,2.4,3,6.5,0.6,9.3C564,438.6,562.2,439.4,560.4,439.4z"
  }))), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M184.4,122.5c0,19.4-15.7,35-35,35s-35-15.7-35-35s15.7-35,35-35S184.4,103.1,184.4,122.5z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M299.7,122.5c0,19.4-15.7,35-35,35s-35-15.7-35-35s15.7-35,35-35S299.7,103.1,299.7,122.5z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M415.2,122.5c0,19.4-15.7,35-35,35s-35-15.7-35-35s15.7-35,35-35S415.2,103.1,415.2,122.5z"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M1586.1,231.6l-43.4-137c-7.7-24.4-30.4-41-56-41H584.5c-25.6,0-48.3,16.6-56,41l-43.4,137H0v326.6h3000.1 V231.6H1586.1z M179.6,423.8c4,3.3,4.6,9.2,1.3,13.2c-1.9,2.3-4.6,3.4-7.3,3.4c-2.1,0-4.2-0.7-6-2.1L118.5,398l49-42.7 c3.9-3.4,9.9-3,13.3,0.9c3.4,3.9,3,9.9-0.9,13.3l-32.2,28.1L179.6,423.8z M270.7,438.4c-1.7,1.4-3.9,2.1-6,2.1 c-2.7,0-5.4-1.2-7.3-3.4c-3.3-4-2.7-9.9,1.3-13.2l32-26.3l-32.2-28.1c-3.9-3.4-4.3-9.4-0.9-13.3c3.4-3.9,9.4-4.3,13.3-0.9l49,42.7 L270.7,438.4z M2796.2,430.8c0,35.3-28.6,64-64,64H470.1c-35.3,0-64-28.6-64-64v-67.5c0-35.3,28.6-64,64-64h2262.2 c35.3,0,64,28.6,64,64v67.5H2796.2z M2879.8,450.4c-7.4,0-13.4-6-13.4-13.4s6-13.4,13.4-13.4s13.4,6,13.4,13.4 C2893.1,444.4,2887.2,450.4,2879.8,450.4z M2879.8,410.1c-7.4,0-13.4-6-13.4-13.4s6-13.4,13.4-13.4s13.4,6,13.4,13.4 C2893.1,404.1,2887.2,410.1,2879.8,410.1z M2879.8,369.8c-7.4,0-13.4-6-13.4-13.4s6-13.4,13.4-13.4s13.4,6,13.4,13.4 C2893.1,363.9,2887.2,369.8,2879.8,369.8z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(Svg10);
export default __webpack_public_path__ + "static/media/10.5a787fe8a5f35876235cf22eb3188209.svg";
export { ForwardRef as ReactComponent };